<template>
  <div id="audit">
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox">
          <select v-model="selected_website" @change="create_drop_down" class="form-control text-uppercase">
          	<option value="https://www.amazon.com">Amazon</option>
            <option value="https://www.harveynorman.com.au">Harvey Norman</option>
            <option value="https://www.bestbuy.com">Best Buy</option>
            <option value="https://www.currys.co.uk">Currys UK</option>
            <option value="https://www.costco.com">Costco</option>
            <option value="https://store.hp.com/us">HP</option>
          </select>
        </div>
        <div class="datebox">
          <select v-model="selected_item" class="form-control text-uppercase">
            <option v-for="d in drop_down_items" :value="d.item_id">{{ d.name }}</option>
          </select>
        </div>
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
  	</div>
    
    <div class="datepickerwrap">
      <h4 class="cust-head">SKU Audit </h4>
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columns" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="typeof(d.field)=='object'">
                 <b-btn class="hint" v-b-tooltip.hover title="Rating Score = (Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rows" :key="r">
            <td v-for="d in columns" :key="d.field" style="border:1px solid silver!important"> 
              <span v-if="typeof(d.field)=='string'">
                <span v-if="d.field=='link'"> 
                  <a :href="r['link']">View Product</a> 
                </span>
                <span v-else> {{r[d.field]}} </span>
              </span>
              <span v-if="typeof(d.field)=='object'">
                <div v-for="it in d.field" :key="it"> <b>{{ratingMapper[it]}}:</b> {{ r[it] }} </div>
              </span>
            </td>
          </tr>
        </tbody>
      </table> 
        
    </div>
    <div class="datepickerwrap">
      <h4 class="cust-head">Position Score</h4>
      <table id="position" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
              {{ d.label  }}
              <span  v-if="d.field == 'category_position'">
                 <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
              </span> 
              <span  v-if="d.field == 'category_13_position'">
                 <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                    2: if System in page 2-3 of results
                    3: if System not in pages 1-3 ">?</b-btn> 
              </span> 
              <span  v-if="d.field == 'search_position'">
                 <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
              </span> 
              <span  v-if="d.field == 'search_13_position'">
                 <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                    2: if System in page 2-3 of search results
                    3: if System not in pages 1-3 ">?</b-btn> 
              </span> 
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rows" :key="r">
            <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
              <span> {{r[d.field]}} </span>
            </td>
          </tr>
        </tbody>
      </table> 
    </div>
    <div class="datepickerwrap">
      <h4 class="cust-head">Compliance Score</h4>
     <table id="compliance" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
              {{ d.label  }} 
              <span  v-if="d.field == 'logo'">
                 <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                    2: Incorrect AMD Badges
                    3: No AMD Badges">?</b-btn> 
              </span> 
              <span  v-if="d.field == 'image_count'">
                 <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                    2: 2 more product images
                    3: 0 or 1 product images">?</b-btn> 
              </span> 
              <span  v-if="d.field == 'nomenclature'">
                 <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                    2: Incorrect AMD Nomenclature
                    3: No AMD Nomenclature">?</b-btn> 
              </span> 
              <span  v-if="d.field == 'message'">
                 <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                    2: Incorrect AMD Messaging
                    3: No AMD Messaging">?</b-btn> 
              </span> 
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rows" :key="r">
            <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
              <span> {{r[d.field]}} </span>
            </td>
          </tr>
        </tbody>
      </table> 
    </div>
  </div>
</template>

<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { VuejsDatatableFactory } from 'vuejs-datatable'

export default {
  name: 'audit',
  components: { Datepicker, VuejsDatatableFactory},
  props:['noSaveProp'],
  data: function () {
    return {
      selected_website:"https://www.harveynorman.com.au",
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      ratingMapper: {
        reviews: 'Reviews',
        rating: 'Rating',
        rating_score: 'Rating Score'
      },
      web_map:{}, 
      drop_down_items:[],
      columns:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Link', field: 'link', sortable: false},
        {label: 'CPU', field: 'cpu', sortable: false},
        {label: 'GPU', field: 'gpu', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating', field: ['reviews','rating','rating_score'], sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
        {label: 'Price', field: 'price', sortable: false},
        {label: 'Offer', field: 'offer', sortable: false}
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rows:[]
    }
  },
  mounted()
  {
    this.fetch_items()
   
  },
  methods: {
    fetch_items(){
      let self = this
      const url = "/api/websites/items"
      this.$http.get(url).then(response => {
        console.log(response.body.data)
        self.web_map = response.body.data
        this.create_drop_down()
        this.refresh()
      }, err => {
        console.log(err)
        console.log('err')
      });
    },

    refresh(){
      let self = this
      const url = "/api/websites/item_details"
      this.$http.post(url, { "website": this.selected_website,"timestamp":this.date.startDate,"item_id":this.selected_item }).then(response => {
        console.log(response.body.data)
        this.rows = [response.body.data]
      }, err => {
        console.log(err)
        console.log('err')
      });
    },

    create_drop_down(){
      this.drop_down_items = this.web_map[this.selected_website]
      this.selected_item = this.drop_down_items[0]["item_id"]
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    }
  }
}

</script>

<style scoped>

.custom-table
  {
    padding: 10px;
    margin:10px;
  }
  .hint
  {
    cursor: pointer;
    background: #f5f5f5;
    color: #080808;
    padding: 3px;
    font-size: 9px;
  } 

</style>